import moment from 'moment';
import { isEmpty, getDistanceInKm, isMobile } from '../utils/helpers';
import Api from '../utils/api';

export const setOaName = (oaName) => ({
  type: 'OA_NAME',
  payload: oaName,
});

export const setPublic = (publicType) => ({
  type: 'OA_PUBLIC',
  payload: publicType,
});

export const setType = (activityType) => ({
  type: 'ACTIVITY_TYPE',
  payload: activityType,
});
export const setActivityPublic = (publicType) => ({
  type: 'OA_PUBLIC_ACT',
  payload: publicType,
});

export const setActivityType = (activityType) => (
  {
    type: 'ACTIVITY_TYPE_ACT',
    payload: activityType,
  }
);

export const setActivityDate = (startDate, endDate = null) => ({
  type: 'SET_DATES_ACT',
  payload: { startDate, endDate },
});

export const setDate = (startDate, endDate = null) => ({
  type: 'SET_DATES',
  payload: { startDate, endDate },
});


const getOasActivitiesStarted = () => ({
  type: 'GET_ACTIVITIES_STARTED',
});

const getOasActivitiesSuccess = (activities) => ({
  type: 'GET_ACTIVITIES_SUCCESS',
  payload: activities,
});

const getOasActivitiesFail = (error) => ({
  type: 'GET_ACTIVITIES_FAIL',
  payload: {
    error,
  },
});


const getOasStarted = () => ({
  type: 'GET_OAS_STARTED',
});

const getOasSuccess = (oas) => ({
  type: 'GET_OAS_SUCCESS',
  payload: oas,
});

const getOasFail = (error) => ({
  type: 'GET_OAS_FAIL',
  payload: error,
});

export const setActiveOa = (oa) => ({
  type: 'SET_ACTIVE_OA',
  payload: oa,
});

export const getOaActivities = (seqCadast) => async (dispatch, getState) => {
  dispatch(getOasActivitiesStarted());

  const { oasState: oas } = getState();
  let response;
  try {
    response = await Api.get(`oa/${seqCadast !== undefined ? seqCadast : oas.activeOa.seq_cadast}/atividades`);
    dispatch(getOasActivitiesSuccess(response.data.data));
  } catch (error) {
    response = error.response;
    dispatch(getOasActivitiesFail(error));
  }
};

// SETMAPS
export const setLat = (lat) => ({
  type: 'SET_LAT',
  payload: lat,
});

export const setLng = (lng) => ({
  type: 'SET_LNG',
  payload: lng,
});

export const setLocationPos = (lat, lng) => ({
  type: 'SET_POS',
  payload: { lat, lng },
});

export const setZoom = (zoom) => ({
  type: 'SET_ZOOM',
  payload: zoom,
});

export const setPos = (lat, lng, oa, zoom = 15) => (dispatch) => {
  if (!isMobile()) {
    dispatch(setActiveOa(oa));
  }
  dispatch(setLocationPos(lat, lng));
  dispatch(setZoom(zoom));
};

export const setUserPos = (lat, lng) => ({
  type: 'SET_USER_POS',
  payload: { lat, lng },
});

export const clearActiveOa = () => ({
  type: 'CLEAR_ACTIVE_OA',
  payload: { seq_cadast: 0 },
});

export const setActiveTab = (tab) => ({
  type: 'SET_ACTIVE_TAB',
  payload: tab,
});
export const getActivitiesByTypeAndDate = () => async (dispatch, getState) => {
  dispatch(getOasActivitiesStarted());

  const { filterState: filters, oasState } = await getState();

  const { activeOa } = oasState;
  if (!isEmpty(activeOa)) {
    const [startDate, endDate] = filters.activityDate;

    const params = {};

    if (filters.activityType.map((el) => el.value).length > 0) {
      params.type = filters.activityType.map((el) => el.value);
    }

    if (startDate) {
      if (startDate.value) params.from = moment(startDate.value, 'DD/MM/YYYY').format('YYYY-MM-DD');
    }

    if (endDate) {
      if (endDate.value) params.to = moment(endDate.value, 'DD/MM/YYYY').format('YYYY-MM-DD');
    }

    if (activeOa.seq_cadast) {
      params.seq_cadast = activeOa.seq_cadast;
    }

    try {
      const { data: response } = await Api.get('searchActivitiesOA', { params });

      if (response.success) {
        dispatch(getOasActivitiesSuccess(response.data));
      } else {
        dispatch(getOasActivitiesFail(response));
      }
    } catch (error) {
      dispatch(getOasActivitiesFail(error));
    }
  }
};

export const getOas = (oaSeqCad = null) => async (dispatch, getState) => {
  dispatch(getOasStarted());
  dispatch(clearActiveOa());

  const { filterState: filters } = getState();

  const params = {
    nom_locali: filters.oaName,
    sig_uf: filters.oaName,
    nom_client: filters.oaName,
    sig_orgafi: filters.oaName,
    uf: filters.oaName,
    cep: filters.oaName,
  };

  let response;

  if (oaSeqCad) {
    try {
      response = await (Api.get(`oa/${oaSeqCad}`));
    } catch (error) {
      dispatch(getOasFail(error.response));
    }
  } else {
    try {
      response = await (Api.get('/oa', { params }));
    } catch (error) {
      dispatch(getOasFail(error.response));
    }
  }

  if (response && response.status === 200) {
    response = response.data;

    if (response.data.length === undefined) {
      if (!isMobile()) {
        dispatch(setActiveOa(response.data));
      }
      response.data = [response.data];
    }

    if (filters.oaActivityDate.length > 0 || filters.oaActivityType.length > 0) {
      const oasFilteredByName = response.data.map((el) => el.seq_cadast);
      if (oasFilteredByName.length === 0) {
        dispatch(getOasFail('Nenhuma encontrada'));
        return;
      }
      const oasParams = {
        seq_cadast: oasFilteredByName,
      };
      if (filters.oaActivityType.map((el) => el.value).length > 0) {
        oasParams.type = filters.oaActivityType.map((el) => el.value);
      }
      if (filters.oaStartDate) {
        oasParams.from = moment(filters.oaStartDate).format();
      }

      if (filters.oaEndDate) {
        oasParams.to = moment(filters.oaEndDate).format();
      }

      const { data: oasFilteredByActivity } = await Api.get('/getOaByActivity', { params: oasParams });

      if (filters.oaPublicType.length > 0) {
        const filterResponse = [];
        if (filters.oaPublicType.find((el) => el.value === 'TOM')) {
          const tomOas = oasFilteredByActivity.data.filter((el) => el.ide_tipo_oa === 'H');
          filterResponse.push(...tomOas);
        }
        if (filters.oaPublicType.find((el) => el.value !== 'TOM')) {
          const rosacruzOas = oasFilteredByActivity.data.filter((el) => el.ide_tipo_oa !== 'H');
          filterResponse.push(...rosacruzOas);
        }
        if (filterResponse.length > 0) {
          dispatch(getOasSuccess(filterResponse));
        } else {
          dispatch(getOasFail('Nenhuma encontrada'));
        }
      } else {
        dispatch(getOasSuccess(oasFilteredByActivity.data));
      }
    } else if (filters.oaPublicType.length > 0) {
      const filterResponse = [];
      if (filters.oaPublicType.find((el) => el.value === 'TOM')) {
        const tomOas = response.data.filter((el) => el.ide_tipo_oa === 'H');
        filterResponse.push(...tomOas);
      }
      if (filters.oaPublicType.find((el) => el.value !== 'TOM')) {
        const rosacruzOas = response.data.filter((el) => el.ide_tipo_oa !== 'H');
        filterResponse.push(...rosacruzOas);
      }
      dispatch(getOasSuccess(filterResponse));
    } else {
      dispatch(getOasSuccess(response.data));
    }


    dispatch(setActiveTab('sobre'));

    if (response.data[0] !== undefined) {
      dispatch(
        setPos(
          parseFloat(response.data[0].num_latitu),
          parseFloat(response.data[0].num_longit),
          response.data.length === 1 ? response.data[0]
            : { seq_cadast: 0 },
        ),
      );
    }
    if (response.data.length > 1) {
      dispatch(setZoom(8));
    }
    // dispatch(setActivityType([]));
    // dispatch(setActivityPublic([]));
    // dispatch(setActivityDate(null, null));
  }
};

const setFilterOptions = (options) => ({
  type: 'SET_FILTER_OPTIONS',
  payload: options,
});

const setActivitiesOptions = (options) => ({
  type: 'SET_ACTIVITIES_OPTIONS',
  payload: options,
});

const setCities = (cities) => ({
  type: 'SET_CITIES',
  payload: cities,
});

export const getFilterOptions = () => async (dispatch, getState) => {
  const { mapState } = getState();
  const { userLat, userLng } = mapState;

  const { data: response } = await Api.get('oa');
  const options = response.data.map((item) => ({ label: item.nom_client, value: item.nom_client, seq_cadast: item.seq_cadast }));

  dispatch(setFilterOptions(options));
  const cities = [];
  const sortedByDistanceOas = response.data.sort((a, b) => {
    const distanceA = getDistanceInKm(userLat, userLng, a.num_latitu, a.num_longit);
    const distanceB = getDistanceInKm(userLat, userLng, b.num_latitu, b.num_longit);
    return Math.floor(distanceA) < Math.floor(distanceB) ? -1 : 1;
  });

  sortedByDistanceOas.forEach((el) => {
    const indexOfCities = cities.findIndex((i) => i.city === el.nom_locali);
    if (cities.length < 5) {
      if (indexOfCities === -1) {
        cities.push({ city: el.nom_locali, uf: el.sig_uf });
      }
    }
  });
  dispatch(setCities(cities));
};

export const getActivitiesOptions = () => async (dispatch) => {
  const { data: response } = await Api.get('activitiesOA');

  const options = response.atividadeEstatuto_tipos.map((item) => (
    {
      label: item.nomeTipoAtividadeEstatuto, value: item.idTipoAtividadeEstatuto,
    }
  ));

  dispatch(setActivitiesOptions(options));
};
